import script from "./SearchDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchDrawer.vue?vue&type=script&setup=true&lang=js"

import "./SearchDrawer.vue?vue&type=style&index=0&id=4e281405&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e281405"]])

export default __exports__